import { internationalPayoutSteps } from "../../../const";
import React, { useCallback } from "react";
import CustomStepper from "../../../../../components/common/CustomStepper";
import { setStep } from "../../../redux/formDataSlice";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { Wrapper, Title } from "./styles";

const stepsItems = internationalPayoutSteps.map((step, index) => ({
  title: step.title,
  description: step.description,
  stepTitle: step.stepTitle,
  stage: index,
}));

const InternationalPayoutForAfrica = () => {
  const step = useAppSelector((state) => state.formData.step);
  const dispatch = useAppDispatch();

  const handleChangeStep = useCallback(
    (index) => {
      if (index >= 0 && index < internationalPayoutSteps.length) {
        dispatch(setStep(index));
      }
    },
    [dispatch],
  );

  const renderStepContent = useCallback(() => {
    const currentStepData = internationalPayoutSteps[step];
    const StepComponent = currentStepData?.component;

    if (StepComponent) {
      return (
        <StepComponent
          handleNext={() => handleChangeStep(step + 1)}
          handlePrevious={() => handleChangeStep(step - 1)}
        />
      );
    }

    return null;
  }, [step, handleChangeStep]);

  return (
    <Wrapper>
      <CustomStepper stages={stepsItems} step={step} setStep={setStep} />
      <Title>{stepsItems[step]?.stepTitle}</Title>
      {renderStepContent()}
    </Wrapper>
  );
};

export default InternationalPayoutForAfrica;
